import { api } from './api'

export const SettingsRepository = {
  async getAppVersions() {
    return api.projectSetting.getAppVersions()
  },
}
